import { ErrorInfiniteRetry }from './ErrorInfiniteRetry';

export default ErrorInfiniteRetry;
